import React from "react";

export const uniqueUsersHeader = {
  header: [
    { title: "User", field: "name" },
    { title: "Platform", field: "platform" },
    { title: "Timestamp", field: "timestamp" }
  ],
  title: "Unique Users Details"
};

export const uncompletedRequestsByIntentHeader = {
  header: [
    { title: "User", field: "user" },
    { title: "Platform", field: "platform" },
    { title: "Last Activity", field: "activity" },
    {
      title: "Request",
      field: "request",
      render: rowData => (
        <span
          style={{
            width: "300px",
            wordWrap: "break-word",
            display: "inline-block",
            overflow: "auto",
            maxHeight: "100px"
          }}
        >
          {rowData.request}
        </span>
      )
    }
  ],
  title: "User Uncompleted Requests Details"
};

export const uncompletedRequestsByUserHeader = {
  header: [
    { title: "User", field: "user" },
    { title: "Platform", field: "platform" },
    { title: "Last Activity", field: "activity" },
    {
      title: "Request",
      field: "request",
      render: rowData => (
        <span
          style={{
            width: "300px",
            wordWrap: "break-word",
            display: "inline-block",
            overflow: "auto",
            maxHeight: "100px"
          }}
        >
          {rowData.request}
        </span>
      )
    }
  ],
  title: "User Uncompleted Requests Details"
};

export const userInteractionLexHeader = {
  header: [
    { title: "User", field: "user" },
    { title: "Method", field: "method" },
    { title: "Input", field: "input" },
    {
      title: "Response",
      field: "response",
      render: rowData => <div style={{ maxHeight: "100px", overflow: "auto" }}>{rowData.response}</div>
    },
    { title: "Timestamp", field: "timestamp" }
  ],
  title: "User Input Details"
};

export const userInteractionAlexaHeader = {
  header: [
    { title: "User", field: "user" },
    { title: "Intent ID", field: "intent" },
    {
      title: "Response",
      field: "response",
      render: rowData => <div style={{ maxHeight: "100px", overflow: "auto" }}>{rowData.response}</div>
    },
    { title: "Timestamp", field: "timestamp" }
  ],
  title: "User Input Details"
};

export const missedUtterancesHeader = {
  header: [
    { title: "Skill Name", field: "skill", hidden: true },
    { title: "Utterance", field: "utterance", filtering: false },
    { title: "Invocations", field: "invocations", filtering: false },
    { title: "Distinct Users", field: "dist_users", filtering: false },
    { title: "First Utterance Date", field: "first_utt_date", filtering: false },
    { title: "Last Utterance Date", field: "last_utt_date", filtering: false },
    {
      title: "Status",
      field: "status",
      lookup: { Missed: "Missed", Reviewed: "Reviewed" }
    }
  ],
  title: "Missed Utterances Details"
};

export const sessionByUserGraph = {
  title: "Number of sessions through time for "
};

export const usageByConnectorHeader = {
  header: [
    { title: "Intent Name", field: "intent_name" },
    { title: "User", field: "username" },
    { title: "Input", field: "input" },
    { title: "Response", field: "response" },
    { title: "Timestamp", field: "timestamap" }
  ],
  title: "Connector Usage Details"
};
